<script setup lang="ts">
const props = defineProps<{
  isOpen: boolean,
  closeOnClickOutside?: boolean
}>();
const emit = defineEmits<{ (event: 'close'): void }>();
const modal = useTemplateRef('modal');
const route = useRoute();

function handleOnClose() {
  emit('close');
};

watch(
  () => route.fullPath, 
  () => { if(props.isOpen) emit('close') }
);

if (import.meta.client) {
  const isScrollLock = useScrollLock(document.body);

  onClickOutside(modal, () => { 
    if (props.closeOnClickOutside) emit('close');
  });

  watch(
    () => props.isOpen,
    newVal => { isScrollLock.value = newVal }
  );
};
</script>

<template>
  <Teleport to="body">
    <div
        v-if="isOpen"
        class="fixed w-screen h-screen top-0 left-0 backdrop-blur-[5px] flex justify-center items-center 
            bg-black/50 z-1000000000000"
    >
        <div 
            class="w-[90%] lg:w-200 max-h-[95%] rounded-3xl bg-white py-6 px-3 lg:px-10 
              relative overflow-y-auto overflow-x-hidden no-scrollbar"
            :class="$slots.head && 'pt-32 lg:pt-52'"
            data-aos="fade-up"
            ref="modal"
        >
          <div 
            class="bg-gray-100 absolute top-4 left-4 rounded-full z-10 w-7 h-7 flex-center cursor-pointer"
            @click="handleOnClose"
          >
            <Icon
              name="maki:cross"
              class="text-gray-500"
              size="10"
            />
          </div>

          <template v-if="$slots.head">
            <div class="head">
              <slot name="head" />
            </div>
          </template>

          <slot />

        </div>
    </div>
  </Teleport>
</template>

<style scoped>
@reference "~/assets/css/main.css";

.modal-enter-active,
.modal-leave-active {
  transition: opacity .3s ease;
}
.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}
.head {
  clip-path: ellipse(50% 100% at 50% 0%);
  @apply
  absolute w-[150%] md:w-[110%] h-30 lg:h-50 top-0 -left-[25%] md:-left-[5%]
}
</style>
